export const getCyrilicNameError = (name, isRequired) => {
    if (!name && isRequired) {
        return 'Полето е задолжително';
    } else if (!/^[аАбБвВгГдДѓЃеЕжЖзЗѕЅиИјЈкКлЛљЉмМнНњЊоОпПрРсСтТќЌуУфФхХцЦчЧџЏшШ\s]*$/.test(name)) {
        return 'Дозволено е само кирилица';
    }
    return '';
}

export const getNameError = (name, isRequred) => {
    if (!name && isRequred) {
        return 'Полето е задолжително';
    } else if (!/^[a-zA-Z\s]*$/.test(name)) {
        return 'Дозволено е само латиница';
    }
    return '';
}

export const getUsernameError = (name) => {
    if (!name) {
        return 'Полето е задолжително';
    } else if (!/^[a-zA-Z.]*$/.test(name)) {
        return 'Дозволено е само латиница и "."';
    }
    return '';
}

export const getEmailError = (email, isRequired) => {
    if (!email && isRequired) {
        return 'Полето е задолжително';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
        return 'Невалиден e-mail';
    }
    return '';
}

export const getPasswordError = (password, isRequired) => {
    if (!password && isRequired) {
        return 'Полето е задолжително';
    }
    return '';
}

// Helper function to format date as YYYY-MM-DD string to avoid timezone issues
export const formatDateForAPI = (date) => {
    if (!date) return null;
    
    // If it's already a string (e.g., from API), return it as is
    if (typeof date === 'string') {
        // Return just the date part if it's an ISO string
        return date.split('T')[0];
    }
    
    // If it's a Date object, format it
    if (date instanceof Date && !isNaN(date)) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    
    return null;
}

// Helper function to parse date string from API avoiding timezone conversion
export const parseDateFromAPI = (dateString) => {
    if (!dateString) return null;

    // If it's already a Date object, return it
    if (dateString instanceof Date) return dateString;

    // If it's not a string, try to convert it
    if (typeof dateString !== 'string') return null;

    const dateStr = dateString.split('T')[0]; // Get only the date part (YYYY-MM-DD)
    const [year, month, day] = dateStr.split('-');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 12, 0, 0);
}
